import { Optional } from '@vimeo/core/types/generic';
import { useOptionalViewer, Viewer } from '@vimeo/viewer';

/**
 * Universal check to see if dev/debug information is visible.
 * Additional checks specific for VPAAS can be added here to extend default `staff` check.
 *
 * @returns whether in current context user can see dev details
 */
export function useCanSeeDevDetails(): boolean {
  const viewer: Optional<Viewer> = useOptionalViewer();

  return viewer?.user?.badge?.type === 'staff';
}
